import { publishEvent, Constants } from '@salesforce/scv-connector-base';
import type { Call } from '@entities/call';
import { CallTypes } from '@entities/call';
import type { DisconnectedCallEventPublisher } from '@usecases/disconnected-call.usecase';
import { HangupResultGenerator } from '@main/generators/hangup-result.generator';
import { Logger } from '@main/utils/logger';
import { SCV_MSG_CHANNEL_NAME } from '@main/config/scv.config';
import type { CallType } from '@main/types/sf-types';

export class DisconnectedCallPublisher
  implements DisconnectedCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  private static channel = new BroadcastChannel(SCV_MSG_CHANNEL_NAME);
  async publish(call: Call): Promise<void> {
    const mapCallType = (type: CallTypes): CallType => {
      return type === CallTypes.INBOUND
        ? Constants.CALL_TYPE.INBOUND
        : type === CallTypes.TRANSFER
        ? Constants.CALL_TYPE.TRANSFER
        : type === CallTypes.ADD_PARTICIPANT
        ? Constants.CALL_TYPE.ADD_PARTICIPANT
        : Constants.CALL_TYPE.OUTBOUND;
    };

    const callResult = HangupResultGenerator.generate(
      call.id,
      mapCallType(call.type),
      call.type === CallTypes.INBOUND ? call.from : call.to,
    );

    this.logger.info('Publisher: Call disconnected', {
      action: 'DisconnectedCall',
      ...call,
    });

    publishEvent({
      eventType: 'HANGUP',
      payload: callResult,
      registerLog: false,
    });

    const message = {
      type: 'SCV.VOICE_CALL_ENDED',
      data: {},
    };

    if (window.parent) {
      window.parent.postMessage(message, '*');
    }
  }
}
